import Api from '@/api/api'
import baseApi from '@/api/apiFileUrl'

export default {
    getDrivers() {
        return Api.get(`/api/Device/GetAllDevicesForSuperAdmin`);
        // return Api.get('Vendor/Driver/GetDrivers')
    },
    getDriverById(id) {
        return Api.get('/api/Driver/GetDriverByID/' + id);
        // return Api.get('Vendor/Driver/GetDriverByID/' + id)
    },
    addDriver(data) {
        return Api.post('/api/Driver/AddDriver', data);
        // return Api.post('Vendor/Driver/AddDriver', data)
    },
    updateDriver(id, data) {
        return Api.put('/api/Driver/UpdateDriver/' + id, data);
        // return Api.put('Vendor/Driver/UpdateDriver/' + id, data)
    },
    deleteDriver(id) {
        return Api.delete('/api/Driver/DeleteDriver/' + id);
        // return Api.delete('Vendor/Driver/DeleteDriver/' + id)
    },
    getColumn() {
        return Api.get('Org/api/Settings/ExplicitColumns?actor=Driver')
    },
    getDriverFile(channelKey,id) {
        // return Api.get('/api/Driver/GetUploadedFile?referenceId=' + id + '&referenceType=Driver')
        return baseApi.get(`/fileupload/API/fileupload/GetFileHistories?channelKey=${channelKey}&referenceID=${id}&referenceType=Driver&tag=`)
    },
    uploadFile(data) {
        return baseApi.post(`/fileupload/API/fileupload/BulkUploadFile?channelKey=${data.channelKey}&referenceID=${data.id}&referenceType=Driver&tags=`,data.data)
        // return Api.post('/api/Driver/UploadDriverFile?ReferenceId=' + data.id + '&ReferenceType=Driver', data.data)
    },
    deleteFile(data) {
        // return Api.delete('Org/api/FileUpload?id=' + id)
        return baseApi.delete(`/fileupload//API/fileupload/DeleteUploadedFile/${data.channelKey}/${data.id}`)
    },
    viewFile(channelKey,id) {
        return baseApi.get(`/fileupload/API/fileupload/GetFileUploadedUrl/${channelKey}/${id}/view`)
    },
    downloadFile(channelKey,id) {
        // return Api.get('/api/Driver/UploadedURL?Id=' + id + '&action=download')
        return baseApi.get(`/fileupload/API/fileupload/GetFileUploadedUrl/${channelKey}/${id}/download`)
    },
    DriverUploadTemplate(formData, config){
        return Api.post(`/api/Driver/UploadTemplate/UploadTemplate`, formData, config)
        // return Api.post(`Vendor/Driver/UploadTemplate?facilityID=${id}`, formData, config)
    },
    DriverDownloadTemplate() {

        return Api.get('/api/Driver/DownloadTemplate/DownloadTemplate', {
            responseType: 'blob',
        })
        // return Api.get('Vendor/Driver/DownloadTemplate', {
        //     responseType: 'blob',
        // })
    },
    driverUploadImage (body) {
        return Api.post(`/api/Driver/UploadImage?referenceID=${body.id}&referenceType=Driver`,body.data);
    },
    DriverUploadImageV2(body){
        return baseApi.post(`/fileupload/API/fileupload/UploadFile?channelKey=${body.channelKey}&referenceID=${body.id}&referenceType=Driver&tag=`,body.data)

    }
}